import { StyledWrapper } from './NotFoundPage.styles';
import { StyledH2 } from '../../components/UI/Typography';

const NotFoundPage = (): JSX.Element => {
  return (
    <StyledWrapper>
      <StyledH2>404: Page Not Found</StyledH2>
    </StyledWrapper>
  );
};

export default NotFoundPage;
